import { Component, computed, inject, output, signal } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../../core/auth/auth.service';

/** Menu do usuário (avatar + dropdown): perfil, preferências, trocar empresa, admin, sair. */
@Component({
  selector: 'app-user-menu',
  standalone: true,
  imports: [],
  templateUrl: './user-menu.component.html',
  styleUrl: './user-menu.component.scss',
})
export class UserMenuComponent {
  private readonly router = inject(Router);
  private readonly authService = inject(AuthService);

  /** Emitido quando o usuário escolhe "Trocar empresa" — o Topbar abre o CompanySelector. */
  readonly switchCompany = output<void>();

  readonly open = signal(false);

  readonly user = computed(() => this.authService.user());
  readonly canAccessAdmin = computed(() => this.authService.canAccessAdmin());
  readonly userInitials = computed(() => {
    const user = this.authService.user();
    if (!user) return '';
    const parts = user.nome.trim().split(' ').filter(Boolean);
    if (parts.length >= 2) {
      return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
    }
    return (parts[0] ?? '').substring(0, 2).toUpperCase();
  });

  toggle(): void {
    this.open.update(v => !v);
  }

  close(): void {
    this.open.set(false);
  }

  onSwitchCompany(): void {
    this.close();
    this.switchCompany.emit();
  }

  onGoToAdmin(): void {
    this.close();
    this.router.navigate(['/admin/dashboard']);
  }

  onLogout(): void {
    this.close();
    this.authService.logout();
  }
}
